/* CRLF -> LF */
const phrases = {
	userExpired: 'Your portal user account has been terminated. Contact us at portal@intergram.cz',
	setBankIdentityUserConfirmation: 'Do you really want to link the bank identity to user account $userName?\n\nNotification email will be sent to $emails.',
	and: 'and',
	userNameMustNotContainSpaces: 'User name must not contain spaces',
	'submissionRole.PER': 'Performers',
	'submissionRole.PRO': 'Producers',
	matchUser: 'Match user',
	userNameMatch: 'User name match',
	candidates: 'Candidates',
	createUser: 'Create user',
	createAndMatch: 'Create and match',
	newUser: 'New user',
	profileIsLinkedToBankIdentity: 'The user profile is linked to a bank identity.',
	profileWasLinkedToBankIdentity: 'The user profile was (but no longer is) linked to a bank identity.',
	'unmatchedBankIdLoginMessage.line1': 'Your bank identity has not been linked to a portal account.',
	'unmatchedBankIdLoginMessage.line2': 'If you have a username/password, use them to log in and your portal account will be linked to the bank identity. Next time you will be able to log in using just Bank iD.',
	'unmatchedBankIdLoginMessage.line3': 'If you do not have access to the portal yet, wait for Intergram to manualy verify your request and contact you.',
	'unmatchedBankIdLoginMessage.userExpired': 'The user account linked to this identity is locked. Contact Intergram.',
	'unmatchedBankIdLoginMessage.generalError': 'An error occurred during the login process.',

	includingDeleted: 'Including deleted',
	termsOfService: 'Terms of service',

	loginWithUserNameAndPassword: 'Login with user name and password',
	loginWithBankId: 'Log in with Bank iD',
	bankIdLoginBlockText: 'Now you can log in with Bank iD. Click the link, select your bank and log in like you would into your online banking.',//'Nově můžete použít Bank iD, po kliknutí na odkaz stačí vybrat svou banku a přihlásit se stejně jako do svého internetového bankovnictví.',
	reallyDeleteBankIdentity: 'Are you sure you want to delete this bank identity?',
	unmatched: 'Unmatched',
	matched: 'Matched',
	deleted: 'Deleted',
	bankIdentities: 'Bank identities',
	removeBankIdentity: 'Remove bank identity',
	reallyRemoveBankIdentity: 'Are you sure you want to remove this bank identity?\n\nYou won\'t be able to use it to log into the portal any more.',
	noBankIdentityConnectedToThisUserAccount: 'Your user account is not linked to any bank identity.\n\nIf you want to use bank identity to log into your portal account, click "Login with Bank iD" next time you log into the portal.',


	'Dashboard': 'Dashboard',
	invalidPassword: 'Invalid password',
	profile: 'Profile',
	IP: 'II',
	NP: 'NI',
	'UsageReport': 'Usage and remuneration',
	'MyRecordings': 'My recordings',
	'Submissions': 'Submissions',
	'Notifications': 'Notifications',
	'SystemSettings': 'System settings',
	'SessionLog': 'Session log',
	'NotificationAdmin': 'Notification administration',
	'UserProfile': 'User profile',
	'SystemMaintenance': 'System outage',
	'dashboard.subHeader.broadcaster': 'Broadcaster',
	'dashboard.subHeader.channel': 'Channel',
	'dashboard.subHeader.audioVideo': 'Audio / Video',
	'backToOverview': 'Back to Dashboard',
	'cancelChanges': 'Cancel changes',
	'maintenanceNotification': 'On *$day* there is planned outage in time *$timeFrom* - *$timeTo* due to maintenance. Your work will be saved prior to start of outage.',
	'performerSignIn': 'Performer web',
	'producerSignIn': 'Producer web',
	'youNeedToSignIn': 'You need to sign in or register in order to log into portal.',
	'stayLoggedIn': 'Stay logged',
	'sessionLogoutInLessThan': 'You will be logged off in less than',
	'minutes.1': 'minute',
	'minutes.2': 'minutes',
	'minutes.3': 'minutes',
	'minutes.4': 'minutes',
	'minutes.x': 'minutes',
	'youHaveBeenLoggedOut': 'Your were logged off',
	'dashboardNoDataMessage': 'No remuneration available.',
	'myRecordingsNoDataMessage': 'There are no recordings available.',
	'rowCount': 'Number of records',
	'next': 'Next',
	'previous': 'Previous',
	'processingRequest': 'Request is being processed',
	'czk': 'CZK',
	'delete': 'Delete',
	'help': 'Help',
	'showAltNames': 'display alternative names',
	'altNames': 'Alternative names',
	'hide': 'hide',
	'logout': 'Log out',
	'noItemsFound': 'No items found',
	'save': 'Save',
	'ok': 'OK',
	'personalInfo': 'Personal info',
	'roleList': 'Role list',
	'cancel': 'Cancel',
	'displayedRecordings': 'Displayed recordings',
	'recordingCount': 'Recording count',
	'pageNumber': 'Go to page',
	'rowsPerPage': 'Records on page',
	'exportSelectionToCSV': 'Export selection to CSV',
	'childRoleRelType.MEM': 'Ensamble memeber',
	'childRoleRelType.ADM': 'Joint representative',
	'footer.socialNetworks': 'Keep in touch on social media',
	'recordingTypeA': 'Audio',
	'recordingTypeV': 'Video',
	'distType.IP': 'II (Identifiable)',
	'distType.NP': 'NI (Non-identifiable)',
	'audioVideo.A': 'Audio',
	'audioVideo.V': 'Video',
	'recordingSource.isrcProtocol': 'From ISRC protocol',
	'recordingSource.other': 'From different sources',
	'readingItems': 'Loading items',
	'mandatoryField': 'Mandatory field',
	'maintenanceToMustBeGreaterThanMaintenanceFrom': 'End of outage time must be later than start of outage ',
	'notificationFromDateMustBeLessThanMaintenanceFrom': 'Notification from must be prior start of outage',
	'maintenanceFromAndToMustBeSameDay': 'Begining and end of outage must be in same day',
	'toDateMustBeGreaterThanFromDate': 'End of notification must be later than its start',
	'new.systemMaintenance': 'New system outage',
	'new.notification': 'New notification',
	'ynBoolean.Y': 'Yes',
	'ynBoolean.N': 'No',
	'validationMessageHeader': 'Please fix errors:',
	'validationIgnorableErrors': 'Form contains errors, that do not prevent saving:',
	'validationIgnorableErrors2': 'Form contains also errors, that do not prevent saving:',
	'validationWarnings': 'Warning',
	'saveAnyway': 'Save anyway',
	'backToForm': 'Back to form',
	'isAMandatoryField': ' is a mandatory field',

	'refresh': 'Refresh',
	'rightHolderReward': 'Remuneration',
	'submissionTransition.NEW2SAVED_FOR_LATER': 'Created and saved for later completion',
	'submissionTransition.NEW2SUBMITTED': 'Created and submitted',
	'submissionTransition.SUBMITTED': 'Submitted',
	'submissionTransition.SUBMITTED2IN_PROGRESS': 'Your submission is being processed',
	'submissionStatusChange': 'Submission status change',
	'changeHistory': 'History of changes',
	'SubmissionAdmin': 'Submission administration',
	'more': 'More',
	'fileSubmission': 'Send your submission',
	'setSubmissionStateTo': 'Set status to',
	'attachANoteOrAFile': 'Add a note or an attachment',
	'uploadingFileProgress': 'Loading file $fileName..$progress%',
	'selectAttachment': 'Select an attachment',
	'fileSizeSumLimitExceeded': 'Files upload resused for exceeded size limit ($limit)',
	'or': 'or',
	'attachmentDragText': 'Drag your files here',
	'maxSize': 'max. size',
	'list': 'List',
	'saveForLater': 'Save for later completion',
	'UserAdmin': 'User administration',
	'AuthenticationCode': 'Authorization codes',
	'Submission': 'Submission',
	'newSubmission': 'New submission',
	'troubleChangingPasswordOrSigningIn': 'Any troubles with password change or login?',
	'sendErrorMessage': 'Sending error',
	'authenticationErrorCode.-20056': 'User entered an invalid code',
	'authenticationErrorCode.-20057': 'The code has expired',
	'forgottenPassword': 'Forgotten password?',
	'passwordChange': 'Password change',
	'passwordReset': 'Creating a new password',
	'passwordHasBeenChanged': 'Your password has been changed',
	'passwordResetEmailSent': 'Link for password change has been sent to *$email* email.',
	'userActivated': 'User activated on $when',
	'userActivationSent': 'Activation email sent on $when',
	'passwordsDoNotMatch': 'Passwords do not match',
	'createYourPortalPassword': 'Create a new password to login to the portal',
	'passwordMustMeetTheseCriteria': 'The password must have',
	'pwd.min8Chars': 'minimum of 8 characters',
	'pwd.upperLower': 'one lower case and one upper case letter',
	'pwd.specialChars': 'minimum of 1 number or a special character',
	'pwd.newPasswordVerification': 'new password and its verification are the same',
	'submit': 'Send',
	'nowYouCanLogIn': 'Now you may login.',
	'activationSuccessful': 'Portal access activation completed.',
	'passwordCreation': 'Password creation',
	'back': 'Back',
	'invalidSmsCode': 'Invalid SMS code entered',
	'invalidUserName': 'Invalid username',
	'smsCodeExpired': 'SMS code expired',
	'invalidActivationCode': 'Invalid activation code',
	'activationCodeExpired': 'Activation code expired',
	'smsNotReceived': 'No SMS received?',
	'enterSmsCode': 'Please enter the SMS login code we have sent to your *mobile phone* ($phone). ',
	'passwordResetHint': 'Please enter your username. Link for password change will be sent to your *email* ',
	'invalidCredentials': 'Invalid credentials',
	'smsAuthentication': 'SMS verification',
	'errorSendingLoginCodeSms': 'Error when sending the SMS with login code',
	'welcomeHeader': 'Welcome to the client portal',
	'contractNeededForAccess': 'To enter the client portal you need to sign a contract with Intergram first.',
	'iHaveAContract': 'I already have a contract',
	'iDontHaveAContract': 'I do not have a contract',
	'needAdvice': 'Do you need an advice?',
	'loginNoun': 'Login',
	'login': 'Login',
	'iAmARegisteredUser': 'I have login credentials for the client portal.',
	'newContract': 'Starting a contract with Intergram',
	'iWantAContract': 'I have no contract but I want to use the Intergram client portal.',
	'sendActivationLink': 'Send the activation link',
	'yes': 'Yes',
	'no': 'No',
	'activationLinkSent': 'Activation link sent successfully',
	'reallySendActivationLink': 'Confirm sending the activation link',
	'duplicateUserName': 'Such username already exists.',
	'terminate': 'Terminate',
	'reactivate': 'Reactivate',
	'new.user': 'New user',
	'usageReportFlag_P.short': 'S',
	'usageReportFlag_P': 'Sales',
	'usageReportFlag_R.short': 'R',
	'usageReportFlag_R': 'Rerun',
	'inDetail': 'Detailed statement',
	'aggregatedItems': 'Aggregated statement',
	'usageReport.time_used_sum.subText': 'hh:mm:ss',
	'usageReport.spins_sum.subText': 'uses',
	'usageReport.ip_gross_amount_sum.subText': 'CZK (gross)',
	'usageReport.np_gross_amount_sum.subText': 'CZK (gross)',
	'doYouWantToSaveOpenSubmission': 'Do you want to save your open submission?',
	'saveAndClose': 'Save and close',
	'doCancelSubmission': 'Yes, cancel my submission',
	'reallyCancelSubmission': 'Confirm cancelling your submission',
	'cancelSubmission': 'Cancel my submission',
	'close': 'Close',
	'closeWithoutSaving': 'Close without saving',
	'youHaveMadeSubmissionChanges': 'You made changes to your open submission, do you want to save them before closing?',
	'anotherModifiedSubmission': 'You have another open submission, do you want to save it and open a new one?',
	'usageReportNoDataMessage': 'You have no usage',
	'saveAndOpenNew': 'Save and open a new one',
	'openWithoutSaving': 'Open a new one without saving',
	'submissionStatusGroup.OPEN': 'Open submissions',
	'submissionStatusGroup.SUBMITTED': 'Sent submissions',
	'submissionStatusGroup.CLOSED': 'Closed submissions',
	'displayedSubmissions': 'Displayed submissions',
	'submissionCount': 'Number of submissions',
	'submissionTransition.NEW2SAVEDFORLATER': 'Created and saved for later completion',
	'submissionTransition.SUBMITTED2INPROGRESS': 'Your submission was accepted and is being processed',
	'usageReportFlagP.short': 'S',
	'usageReportFlagP': 'Sales',
	'usageReportFlagR.short': 'R',
	'usageReportFlagR': 'Rerun',
	'usageReport.timeUsedSum.subText': 'usage times',
	'usageReport.spinsSum.subText': 'usage',
	'usageReport.ipGrossAmountSum.subText': 'CZK (gross)',
	'usageReport.npGrossAmountSum.subText': 'CZK (gross)',
};

const columnTexts = {
	'notification_channel': 'Channel',
	'text': 'Text',
	'maintenanceFrom': 'Start',
	'maintenanceTo': 'End',
	'from_date': 'From ',
	'to_date': 'To',
	'logoutWarningThreshold': 'Logout notification period (minutes)',
	'sessionDurationInMinutes': 'Session duration (minutes)',
	'account_category': 'Rights category',
	'usage_year': 'Year of usage',
	'income_type': 'Income type',
	'reward_amount': 'remuneration amount',
	'reward_netto': 'To be paid',
	'categoryName.dashboard': 'Rights category',
	'effectivePeriodId.dashboard': 'Year of usage',
	'distType.dashboard': 'Income type',
	brutto: 'Gross',
	netto: 'Net',
	'brutto.dashboard': 'Remun. amount',
	'netto.dashboard': 'To be paid',
	'total_netto_reward': 'Total amount to be paid',
	'highest_reward_category': 'Highest remuneration in category',
	'top_channel': 'Most often on channel',
	'most_profitable_recording': 'Most profitable recording',
	'person_group': 'Person | Group',
	'role': 'Role',
	'distribution_period': 'Distribution period',
	'session_id': 'ID',
	'user': 'User',
	'proxy_user': 'Proxy user',
	'login_type': 'Login type',
	'login_time': 'Login time',
	'logout_time': 'Logout time',
	'last_access_time': 'Last login',
	'recording': 'Recording',
	'production_release_year': 'Year of production (release)',
	'length': 'Duration',
	'audio_video': 'Audio/Video',
	'isrc': 'ISRC',
	'from': 'From ',
	'to': 'To',
	'profile_name': 'Profile name',
	'first_name': 'Name',
	'last_name': 'Surname',
	'date_of_birth': 'Date of birth',
	'profile_type': 'Profile type',
	'email': 'E-mail',
	'phone': 'Phone',
	'street_and_house_number': 'Street and house number',
	'city': 'City',
	'zip_code': 'Zip code',
	'day': 'Day',
	'notification_from_date': 'Notification from',
	'comments': 'Comment',
	'is_deleted': 'Deleted',
	'is_active': 'Active',
	'created_when': 'Created',
	'edited_when': 'Edited',
	'maintenance': 'Maintenance',
	'notificationChannel': 'Channel',
	'fromDate': 'From',
	'toDate': 'To',
	'accountCategory': 'Rights category',
	'usageYear': 'Year of usage',
	'incomeType': 'Income type',
	'rewardAmount': 'Remuneration amount',
	'rewardNetto': 'To be paid',
	'totalNettoReward': 'Total amount to be paid',
	'highestRewardCategory': 'Highest remuneration in category',
	'topChannel': 'Most often on channel',
	'mostProfitableRecording': 'Most profitable recording',
	'personGroup': 'Person | Group',
	'distributionPeriod': 'Distribution period',
	'sessionId': 'ID',
	'proxyUser': 'Proxy user',
	'loginType': 'Login type',
	'loginTime': 'Login time',
	'logoutTime': 'Logout time',
	'lastAccessTime': 'Last login',
	'productionReleaseYear': 'Year of production (release)',
	'audioVideo': 'Audio/Video',
	'profileName': 'Profile name',
	'firstName': 'Name',
	'lastName': 'Surname',
	'dateOfBirth': 'Date of birth',
	'profileType': 'Profile type',
	'streetAndHouseNumber': 'Street and house number',
	'zipCode': 'Zip code',
	'notificationFromDate': 'Notification from',
	'isDeleted': 'Deleted',
	'isActive': 'Active',
	'createdWhen': 'Created',
	'editedWhen': 'Edited',

	'nameAndSurname': 'Name and surname',
	'production_year': 'Production year',
	'release_year': 'Release year',
	'is_isrc_protocol': 'ISRC protocol',
	'station': 'Station',
	'last_modified': 'Last modified',
	'usage_date': 'Usage date',
	'recording_type_id': 'Audio / video',
	'recording_id': 'Recording id',
	'time_used': 'Time used',
	'spins': 'Usage count',
	'ip_gross_amount': 'Identifiable income',
	'np_gross_amount': 'Non-identifiable income',
	'ip_gross_amount.short': 'II amount',
	'np_gross_amount.short': 'NI amount',
	'is_rerun': 'Rerun',
	'is_sale': 'Sale',
	'title': 'Title',
	'subtitle': 'Sub-title',
	'broadcaster': 'Broadcaster',
	'party': 'Person',
	'from_date.authenticationCode': 'Valid from',
	'to_date.authenticationCode': 'Valid to',
	'used_when': 'Used',
	'authentication_code_type': 'Code type',
	'authentication_code_status': 'Status',
	'authentication_code': 'Code',
	'sent_to': 'Sent to',
	'user_name': 'User name',
	'display_name': 'Name',
	'language': 'Language',
	'activated': 'Activated',
	'languageId.form': 'Language',
	'smsCode': 'SMS code',
	'password': 'Password',
	'attachments': 'Attachments',
	'submission_id': 'Submission id',
	'password_verification': 'Password verification',
	newPassword: 'New password',
	oldPassword: 'Current password',
	parties: 'Parties',
	'newPasswordVerification': 'New password verification',
	'name.submission': 'Submission title',
	'type.submission': 'Submission topic',
	'role_id.submission': 'Submission on behalf of',
	'comments.submission': 'Note',
	'submitted_when.submission': 'Submitted (created)',
	'status': 'Status',
	'submitted_by': 'Submitted by',
	'productionYear': 'Production year',
	'releaseYear': 'Release year',
	'isIsrcProtocol': 'ISRC protocol',
	'lastModified': 'Last change',
	'usageDate': 'Usage date and time',
	'recordingTypeId': 'Audio / video',
	'recordingId': 'Recording id',
	'timeUsed': 'Used time',
	'ipGrossAmount': 'II amount',
	'npGrossAmount': 'NI amount',
	'isRerun': 'Rerun',
	'isSale': 'Sale',
	'fromDate.authenticationCode': 'Valid from',
	'toDate.authenticationCode': 'Valid to',
	'usedWhen': 'Used',
	'authenticationCodeType': 'Code type',
	'authenticationCodeStatus': 'State',
	'authenticationCode': 'Code',
	'sentTo': 'Sent to',
	'userName': 'User name',
	'displayName': 'Name',
	'submissionId': 'Submission id',
	'passwordVerification': 'Password verification',
	'roleId.submission': 'Submission on behalf of',
	'submittedWhen.submission': 'Submitted (created)',
	'submittedBy': 'Submitted by',
	'born.short': 'b.',
};

const l10n = {
	phrases,
	columnTexts
};

export default l10n;
